import { RenderPass as ThreeRenderPass } from 'three/examples/jsm/postprocessing/RenderPass'

/** Class used as the global render */
export default class RenderPass extends ThreeRenderPass {}